var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fixed-width" }, [
    _c(
      "div",
      {
        staticClass: "card-body fluid",
        staticStyle: {
          padding: "1rem !important",
          "padding-bottom": "0 !important",
          "padding-top": "0.75rem !important",
        },
      },
      [
        _c(
          "b-row",
          { staticClass: "text-black att-text pt-0 pb-1" },
          [
            _c(
              "b-col",
              {
                staticClass:
                  "d-flex justify-content-start align-items-center flex-row mb-1",
                attrs: { cols: "9" },
              },
              [
                _c("span", { staticStyle: { "font-size": "22px" } }, [
                  _vm._v(_vm._s(_vm.layerName) + " MetaData"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "download-border ml-3",
                    on: { click: _vm.createReport },
                  },
                  [_c("fa", { attrs: { icon: ["fas", "download"] } })],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-col",
              {
                staticClass:
                  "d-flex justify-content-end align-items-center mb-2",
                attrs: { cols: "3" },
              },
              [
                _c("fa", {
                  staticClass: "float-right clickable mt-1 mx-1",
                  attrs: {
                    id: "minOrMaxAttributeElement",
                    title: _vm.attributesMinimized
                      ? "Maximize Attributes"
                      : "Minimize Attributes",
                    icon: [
                      "fas",
                      _vm.attributesMinimized
                        ? "window-maximize"
                        : "window-minimize",
                    ],
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit(
                        _vm.attributesMinimized
                          ? "maximizeAttributes"
                          : "minimizeAttributes"
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("fa", {
                  staticClass: "float-right mt-1",
                  staticStyle: { cursor: "pointer" },
                  attrs: { icon: ["fas", "window-close"] },
                  on: {
                    click: function ($event) {
                      return _vm.closeAnaAttTable()
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.attributesMinimized,
                expression: "!attributesMinimized",
              },
            ],
            staticClass: "scrollable",
          },
          [
            _vm._l(
              _vm.anaAttribResponse.filter(
                (resp) =>
                  resp.name != "long" &&
                  resp.name != "lat" &&
                  resp.name != "coords" &&
                  resp.name != "region"
              ),
              function (resp, index) {
                return _c(
                  "b-row",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.attributesMinimized,
                        expression: "!attributesMinimized",
                      },
                    ],
                    key: index,
                    staticClass: "row py-1",
                  },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "att-text capitalize",
                        attrs: { cols: "4" },
                      },
                      [_vm._v(_vm._s(resp.name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "att-value blue",
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          id: "editor" + index,
                          cols: "8",
                          title: "Copy Value",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.copyText(resp.value)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(resp.value) + "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }
            ),
            _vm._v(" "),
            _c("hr", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.attributesMinimized,
                  expression: "!attributesMinimized",
                },
              ],
            }),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.attributesMinimized,
                    expression: "!attributesMinimized",
                  },
                ],
                staticClass: "mb-1",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  {
                    staticStyle: { "font-size": "20px" },
                    attrs: { cols: "6" },
                  },
                  [_vm._v("\n          Minimum Distance\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass:
                      "mb-1 d-flex justify-content-center align-items-center pl-4",
                    staticStyle: { "font-size": "18px" },
                    attrs: { cols: "4" },
                    on: {
                      click: function ($event) {
                        return _vm.calculateNearestDistance()
                      },
                    },
                  },
                  [
                    _c("b-button", { staticClass: "calcBtn btn-sm" }, [
                      _vm._v("Calculate"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "2" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "mb-2 blue",
                staticStyle: { height: "12px", "font-size": "12px" },
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "pl-2",
                    staticStyle: { "text-align": "left" },
                    attrs: { cols: "5" },
                  },
                  [_vm._v("ROAD TYPE")]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticStyle: { "text-align": "center" },
                    attrs: { cols: "3" },
                  },
                  [_vm._v("DISTANCE")]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticStyle: { "text-align": "center" },
                    attrs: { cols: "4" },
                  },
                  [_vm._v("LON/LAT")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.attributesMinimized,
                    expression: "!attributesMinimized",
                  },
                ],
                staticClass: "nearestDistanceWindow",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  { staticClass: "mb-1", attrs: { cols: "5" } },
                  _vm._l(_vm.items, function (item, index) {
                    return _c(
                      "b-row",
                      { key: index, attrs: { "no-gutters": "" } },
                      [
                        _c("label", { staticClass: "capitalize" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedItems,
                                expression: "selectedItems",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: item,
                              checked: Array.isArray(_vm.selectedItems)
                                ? _vm._i(_vm.selectedItems, item) > -1
                                : _vm.selectedItems,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedItems,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = item,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedItems = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedItems = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedItems = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(
                            "\n              " + _vm._s(item) + "\n            "
                          ),
                        ]),
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "results-col", attrs: { cols: "3" } },
                  [
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.nearestDistances[0] && _vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestDistances[0])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestDistances[0]) + " km")]
                          )
                        : _vm.nearestDistances[0] && !_vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestDistances[0])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestDistances[0]) + " miles")]
                          )
                        : _vm.selectedItems.includes("motorway") &&
                          _vm.calculatingNearest
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center py-2",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.nearestDistances[1] && _vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestDistances[1])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestDistances[1]) + " km")]
                          )
                        : _vm.nearestDistances[1] && !_vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestDistances[1])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestDistances[1]) + " miles")]
                          )
                        : _vm.selectedItems.includes("trunk") &&
                          _vm.calculatingNearest
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center py-2",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.nearestDistances[2] && _vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestDistances[2])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestDistances[2]) + " km")]
                          )
                        : _vm.nearestDistances[2] && !_vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestDistances[2])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestDistances[2]) + " miles")]
                          )
                        : _vm.selectedItems.includes("primary") &&
                          _vm.calculatingNearest
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center py-2",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.nearestDistances[3] && _vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestDistances[3])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestDistances[3]) + " km")]
                          )
                        : _vm.nearestDistances[3] && !_vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestDistances[3])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestDistances[3]) + " miles")]
                          )
                        : _vm.selectedItems.includes("secondary") &&
                          _vm.calculatingNearest
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center py-2",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "mb-1 results-col", attrs: { cols: "4" } },
                  [
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.nearestSegments[0]
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestSegments[0])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestSegments[0]))]
                          )
                        : _vm.selectedItems.includes("motorway") &&
                          _vm.calculatingNearest
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-center py-2",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.nearestSegments[1]
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestSegments[1])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestSegments[1]))]
                          )
                        : _vm.selectedItems.includes("trunk") &&
                          _vm.calculatingNearest
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-center py-2",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.nearestSegments[2]
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestSegments[2])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestSegments[2]))]
                          )
                        : _vm.selectedItems.includes("primary") &&
                          _vm.calculatingNearest
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-center py-2",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.nearestSegments[3]
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.nearestSegments[3])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.nearestSegments[3]))]
                          )
                        : _vm.selectedItems.includes("secondary") &&
                          _vm.calculatingNearest
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-center py-2",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("hr", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.attributesMinimized,
                  expression: "!attributesMinimized",
                },
              ],
            }),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.attributesMinimized,
                    expression: "!attributesMinimized",
                  },
                ],
                staticClass: "mb-1",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  {
                    staticStyle: { "font-size": "20px" },
                    attrs: { cols: "7" },
                  },
                  [_vm._v("\n          Total Distance\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "mb-2 blue",
                staticStyle: { height: "12px", "font-size": "12px" },
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "pl-2",
                    staticStyle: { "text-align": "left" },
                    attrs: { cols: "4" },
                  },
                  [_vm._v("ROAD TYPE")]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "pl-2",
                    staticStyle: { "text-align": "center" },
                    attrs: { cols: "8" },
                  },
                  [_vm._v("DISTANCE")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.attributesMinimized,
                    expression: "!attributesMinimized",
                  },
                ],
                staticClass: "totalDistanceWindow",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  { staticClass: "mb-1", attrs: { cols: "4" } },
                  _vm._l(_vm.items, function (item, index) {
                    return _c(
                      "b-row",
                      { key: index, attrs: { "no-gutters": "" } },
                      [
                        _c("label", { staticClass: "capitalize" }, [
                          _vm._v(
                            "\n              " + _vm._s(item) + "\n            "
                          ),
                        ]),
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-1 results-col",
                    staticStyle: { "padding-left": "1rem" },
                    attrs: { cols: "8" },
                  },
                  [
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.totalDistances[0] && _vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.totalDistances[0])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.totalDistances[0]) + " km")]
                          )
                        : _vm.totalDistances[0] && !_vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.totalDistances[0])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.totalDistances[0]) + " miles")]
                          )
                        : _vm.calculatingTotal
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-center py-1",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.totalDistances[1] && _vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.totalDistances[1])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.totalDistances[1]) + " km")]
                          )
                        : _vm.totalDistances[1] && !_vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.totalDistances[1])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.totalDistances[1]) + " miles")]
                          )
                        : _vm.calculatingTotal
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-center py-1",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.totalDistances[2] && _vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.totalDistances[2])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.totalDistances[2]) + " km")]
                          )
                        : _vm.totalDistances[2] && !_vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.totalDistances[2])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.totalDistances[2]) + " miles")]
                          )
                        : _vm.calculatingTotal
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-center py-1",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("b-row", { attrs: { "no-gutters": "" } }, [
                      _vm.totalDistances[3] && _vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.totalDistances[3])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.totalDistances[3]) + " km")]
                          )
                        : _vm.totalDistances[3] && !_vm.isAnaKilo
                        ? _c(
                            "div",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.copyText(_vm.totalDistances[3])
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.totalDistances[3]) + " miles")]
                          )
                        : _vm.calculatingTotal
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-center py-1",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm blue",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }